import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  constructor(private msalService: MsalService, private router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          // Option 1: Redirect to login using MSAL
          this.msalService.instance.logoutRedirect({
            postLogoutRedirectUri: window.location.origin
          });

          // Option 2: Initiate login redirect (if you want to prompt login)
          // this.msalService.loginRedirect();

          // Option 3: Navigate to a specific login route
          // this.router.navigate(['/login']);

          // Optionally, you can return a specific observable or rethrow the error
          return throwError(() => new Error('Unauthorized. Redirecting to login.'));
        }
        return throwError(() => error);
      })
    );
  }
}
